var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-confirm-dialog'),_c('notifications',{attrs:{"group":"alert"}}),_c('router-view'),_c('link',{attrs:{"rel":"stylesheet","type":"text/css","href":"https://icons.corenroll.com/icon-lib/ctsicons-lib.css"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }